export const setCustomEvent = (name, data) => {
  setTimeout(() => {
    const event = new CustomEvent(name, { detail: data });
    window.dispatchEvent(event);
  }, 0);
};
